import React, { useState } from 'react'

interface ImageUploadProps {
  onFileSelect: (file: File) => void;
  currentImage?: string | null;
  maxSize?: number; // Add maxSize prop in KB 
  imgClasses?: string;
}

export default function ImageUpload({ 
  onFileSelect,
  currentImage,
  maxSize = 2048, // Default to 2MB (2048KB)
  imgClasses = ""
}: ImageUploadProps) {
  const [error, setError] = useState<string | null>(null);
  
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(null);
    const file = event.target.files?.[0];
    if (!file) return;

    // Check file type
    const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      setError('Please upload a JPG, PNG, or WebP file');
      return;
    }

    // Check file size using maxSize prop
    const maxBytes = maxSize * 1024; // Convert KB to bytes
    if (file.size > maxBytes) {
      setError(`File size must be less than ${maxSize}KB`);
      return;
    }

    onFileSelect(file);
  };

  return (
    <div>
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={handleUpload}
        className="w-full p-2 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      {error && (
        <p className="text-semanticColors-warning text-sm mt-1">{error}</p>
      )}
      {currentImage && (
        <img 
          src={currentImage} 
          alt="Preview" 
          className={`mt-2 max-w-xs rounded-lg ${imgClasses}`}
        />
      )}
    </div>
  )
}
